window.UPGRADE_VARIANTS = {
  10: 44062844158017,
  11: 44062844190785,
  15: 50858759880769,
  20: 50858759913537,
  21: 50858759946305,
  25: 50858759979073,
  29: 50858760011841,
  30: 50858760044609,
  39: 50858760077377,
  40: 50858760110145,
  44: 50858760142913,
  45: 50858760175681,
  49: 50858760208449,
  50: 50858760241217,
  55: 50858760273985,
  59: 50858760306753,
  60: 50858760339521,
  62: 50858760372289,
  65: 50858760405057,
  69: 50858760437825,
  70: 50858760470593,
  74: 50858760503361,
  79: 50858760536129,
  80: 50858760568897,
  85: 50858760601665,
  89: 50858760634433,
  90: 50858760667201,
  95: 50858760699969,
  99: 50858760732737,
  100: 50858760765505,
  109: 50858760798273,
  110: 50858760831041,
  119: 50858760863809,
  120: 50858760896577,
  124: 50858760929345,
  130: 50858760962113,
  139: 50858760994881,
  140: 50858761027649,
  145: 50858761060417,
  149: 50858761093185,
  150: 50858761125953,
  151: 50858761158721,
  153: 50858761191489,
  159: 50858761224257,
  160: 50858761257025,
  165: 50858761289793,
  170: 50858761322561,
  175: 50858761355329,
  179: 50858761388097,
  180: 50858761420865,
  185: 50858761453633,
  189: 50858761486401,
  190: 50858761519169,
  195: 50858761551937,
  199: 50858761584705,
  200: 50858761617473,
  205: 50858761650241,
  209: 50858761683009,
  210: 50858761715777,
  214: 50858761748545,
  219: 50858761781313,
  220: 50858761814081,
  225: 50858761846849,
  229: 50858761879617,
  230: 50858761912385,
  234: 50858761945153,
  235: 50858761977921,
  239: 50858762010689,
  240: 50858762043457,
  245: 50858762076225,
  246: 50858762108993,
  249: 50858762141761,
  250: 50858762174529,
  259: 50858762207297,
  269: 50858762240065,
  270: 50858762272833,
  273: 50858762305601,
  275: 50858762338369,
  279: 50858762371137,
  280: 50858762403905,
  290: 50858762436673,
  295: 50858762469441,
  299: 50858762502209,
  300: 50858762534977,
  305: 50858762567745,
  309: 50858762600513,
  310: 50858762633281,
  312: 50858762666049,
  319: 50858762698817,
  320: 50858762731585,
  325: 50858762764353,
  329: 50858762797121,
  330: 50858762829889,
  339: 50858762862657,
  343: 50858762895425,
  345: 50858762928193,
  349: 50858762960961,
  350: 50858762993729,
  351: 50858763026497,
  355: 50858763059265,
  359: 50858763092033,
  363: 50858763124801,
  365: 50858763157569,
  369: 50858763190337,
  374: 50858763223105,
  379: 50858763255873,
  380: 50858763288641,
  385: 50858763321409,
  392: 50858763354177,
  395: 50858763386945,
  399: 50858763419713,
  400: 50858763452481,
  404: 50858763485249,
  405: 50858763518017,
  409: 50858763550785,
  410: 50858763583553,
  413: 50858763616321,
  415: 50858763649089,
  416: 50858763681857,
  419: 50858763714625,
  420: 50858763747393,
  423: 50858763780161,
  425: 50858763812929,
  428: 50858763845697,
  429: 50858763878465,
  430: 50858763911233,
  439: 50858763944001,
  440: 50858763976769,
  449: 50858764009537,
  450: 50858764042305,
  455: 50858764075073,
  456: 50858764107841,
  459: 50858764140609,
  460: 50858764173377,
  463: 50858764206145,
  469: 50858764238913,
  470: 50858764271681,
  472: 50858764304449,
  475: 50858764337217,
  479: 50858764369985,
  480: 50858764402753,
  483: 50858764435521,
  486: 50858764468289,
  489: 50858764501057,
  490: 50858764533825,
  494: 50858764566593,
  495: 50858764599361,
  499: 50858764632129,
  500: 50858764664897,
  503: 50858764697665,
  509: 50858764730433,
  510: 50858764763201,
  519: 50858764795969,
  520: 50858764828737,
  524: 50858764861505,
  529: 50858764894273,
  539: 50858764927041,
  540: 50858764959809,
  545: 50858764992577,
  549: 50858765025345,
  550: 50858765058113,
  552: 50858765090881,
  553: 50858765123649,
  559: 50858765156417,
  560: 50858765189185,
  570: 50858765221953,
  575: 50858765254721,
  576: 50858765287489,
  579: 50858765320257,
  580: 50858765353025,
  589: 50858765385793,
  590: 50858765418561,
  595: 50858765451329,
  599: 50858765484097,
  600: 50858765516865,
  609: 50858765549633,
  619: 50858765582401,
  623: 50858765615169,
  625: 50858765647937,
  626: 50858765680705,
  629: 50858765713473,
  630: 50858765746241,
  632: 50858765779009,
  639: 50858765811777,
  640: 50858765844545,
  645: 50858765877313,
  649: 50858765910081,
  650: 50858765942849,
  659: 50858765975617,
  660: 50858766008385,
  665: 50858766041153,
  669: 50858766073921,
  674: 50858766106689,
  679: 50858766139457,
  680: 50858766172225,
  689: 50858766204993,
  690: 50858766237761,
  693: 50858766270529,
  695: 50858766303297,
  699: 50858766336065,
  700: 50858766368833,
  709: 50858766401601,
  710: 50858766434369,
  712: 50858766467137,
  719: 50858766499905,
  726: 50858766532673,
  729: 50858766565441,
  730: 50858766598209,
  739: 50858766630977,
  745: 50858766663745,
  749: 50858766696513,
  759: 50858766729281,
  763: 50858766762049,
  769: 50858766794817,
  774: 50858766827585,
  779: 50858766860353,
  780: 50858766893121,
  789: 50858766925889,
  791: 50858766958657,
  792: 50858766991425,
  794: 50858767024193,
  795: 50858767056961,
  798: 50858767089729,
  799: 50858767122497,
  800: 50858767155265,
  809: 50858767188033,
  819: 50858767220801,
  825: 50858767253569,
  839: 50858767286337,
  840: 50858767319105,
  845: 50858767351873,
  846: 50858767384641,
  849: 50858767417409,
  850: 50858767450177,
  853: 50858767482945,
  859: 50858767515713,
  865: 50858767548481,
  869: 50858767581249,
  872: 50858767614017,
  880: 50858767646785,
  889: 50858767679553,
  895: 50858767712321,
  899: 50858767745089,
  900: 50858767777857,
  909: 50858767810625,
  910: 50858767843393,
  929: 50858767876161,
  930: 50858767908929,
  945: 50858767941697,
  949: 50858767974465,
  950: 50858768007233,
  959: 50858768040001,
  960: 50858768072769,
  969: 50858768105537,
  973: 50858768138305,
  979: 50858768171073,
  980: 50858768203841,
  989: 50858768236609,
  995: 50858768269377,
  998: 50858768302145,
  999: 50858768334913,
  1000: 50858768367681,
  1009: 50858768400449,
  1024: 50858768433217,
  1025: 50858768465985,
  1030: 50858768498753,
  1040: 50858768531521,
  1043: 50858768564289,
  1045: 50858768597057,
  1049: 50858768629825,
  1050: 50858768662593,
  1059: 50858768695361,
  1095: 50858768728129,
  1099: 50858768760897,
  1100: 50858768793665,
  1112: 50858768826433,
  1113: 50858768859201,
  1120: 50858768891969,
  1125: 50858768924737,
  1145: 50858768957505,
  1149: 50858768990273,
  1150: 50858769023041,
  1155: 50858769055809,
  1169: 50858769088577,
  1183: 50858769121345,
  1190: 50858769154113,
  1192: 50858769186881,
  1195: 50858769219649,
  1196: 50858769252417,
  1197: 50858769285185,
  1199: 50858769317953,
  1200: 50858769350721,
  1209: 50858769383489,
  1224: 50858769416257,
  1225: 50858769449025,
  1229: 50858769481793,
  1245: 50858769514561,
  1249: 50858769547329,
  1250: 50858769580097,
  1253: 50858769612865,
  1260: 50858769645633,
  1269: 50858769678401,
  1272: 50858769711169,
  1280: 50858769743937,
  1284: 50858769776705,
  1295: 50858769809473,
  1299: 50858769842241,
  1300: 50858769875009,
  1309: 50858769907777,
  1320: 50858769940545,
  1323: 50858769973313,
  1324: 50858770006081,
  1330: 50858770038849,
  1345: 50858770071617,
  1349: 50858770104385,
  1350: 50858770137153,
  1352: 50858770169921,
  1365: 50858770202689,
  1395: 50858770235457,
  1399: 50858770268225,
  1400: 50858770300993,
  1421: 50858770333761,
  1432: 50858770366529,
  1435: 50858770399297,
  1440: 50858770432065,
  1445: 50858770464833,
  1449: 50858770497601,
  1470: 50858770530369,
  1476: 50858770563137,
  1495: 50858770595905,
  1498: 50858770628673,
  1499: 50858770661441,
  1500: 50858770694209,
  1512: 50858770726977,
  1520: 50858770759745,
  1533: 50858770792513,
  1540: 50858770825281,
  1545: 50858770858049,
  1560: 50858770890817,
  1575: 50858770923585,
  1592: 50858770956353,
  1595: 50858770989121,
  1599: 50858771021889,
  1600: 50858771054657,
  1603: 50858771087425,
  1610: 50858771120193,
  1640: 50858771152961,
  1645: 50858771185729,
  1649: 50858771218497,
  1672: 50858771251265,
  1673: 50858771284033,
  1680: 50858771316801,
  1691: 50858771349569,
  1695: 50858771382337,
  1699: 50858771415105,
  1712: 50858771447873,
  1715: 50858771480641,
  1716: 50858771513409,
  1740: 50858771546177,
  1743: 50858771578945,
  1745: 50858771611713,
  1752: 50858771644481,
  1760: 50858771677249,
  1771: 50858771710017,
  1789: 50858771742785,
  1795: 50858771775553,
  1799: 50858771808321,
  1800: 50858771841089,
  1813: 50858771873857,
  1832: 50858771906625,
  1840: 50858771939393,
  1849: 50858771972161,
  1850: 50858772004929,
  1853: 50858772037697,
  1875: 50858772070465,
  1880: 50858772103233,
  1883: 50858772136001,
  1890: 50858772168769,
  1895: 50858772201537,
  1899: 50858772234305,
  1912: 50858772267073,
  1925: 50858772299841,
  1945: 50858772332609,
  1949: 50858772365377,
  1953: 50858772398145,
  1960: 50858772430913,
  1992: 50858772463681,
  1995: 50858772496449,
  1999: 50858772529217,
  2000: 50858772561985,
  2030: 50858772594753,
  2049: 50858772627521,
  2065: 50858772660289,
  2072: 50858772693057,
  2093: 50858772725825,
  2095: 50858772758593,
  2099: 50858772791361,
  2100: 50858772824129,
  2102: 50858772856897,
  2125: 50858772889665,
  2130: 50858772922433,
  2135: 50858772955201,
  2145: 50858772987969,
  2149: 50858773020737,
  2152: 50858773053505,
  2160: 50858773086273,
  2169: 50858773119041,
  2170: 50858773151809,
  2199: 50858773184577,
  2200: 50858773217345,
  2232: 50858773250113,
  2233: 50858773282881,
  2240: 50858773315649,
  2249: 50858773348417,
  2295: 50858773381185,
  2299: 50858773413953,
  2300: 50858773446721,
  2320: 50858773479489,
  2340: 50858773512257,
  2349: 50858773545025,
  2360: 50858773577793,
  2373: 50858773610561,
  2392: 50858773643329,
  2394: 50858773676097,
  2396: 50858773708865,
  2399: 50858773741633,
  2400: 50858773774401,
  2415: 50858773807169,
  2440: 50858773839937,
  2443: 50858773872705,
  2450: 50858773905473,
  2454: 50858773938241,
  2455: 50858773971009,
  2472: 50858774003777,
  2475: 50858774036545,
  2480: 50858774069313,
  2485: 50858774102081,
  2490: 50858774134849,
  2495: 50858774167617,
  2499: 50858774200385,
  2501: 50858774233153,
  2513: 50858774265921,
  2530: 50858774298689,
  2552: 50858774331457,
  2555: 50858774364225,
  2560: 50858774396993,
  2574: 50858774429761,
  2583: 50858774462529,
  2590: 50858774495297,
  2595: 50858774528065,
  2599: 50858774560833,
  2632: 50858774593601,
  2634: 50858774626369,
  2645: 50858774659137,
  2695: 50858774691905,
  2698: 50858774724673,
  2701: 50858774757441,
  2712: 50858774790209,
  2745: 50858774822977,
  2760: 50858774855745,
  2765: 50858774888513,
  2792: 50858774921281,
  2793: 50858774954049,
  2795: 50858774986817,
  2799: 50858775019585,
  2800: 50858775052353,
  2840: 50858775085121,
  2845: 50858775117889,
  2860: 50858775150657,
  2863: 50858775183425,
  2872: 50858775216193,
  2899: 50858775248961,
  2900: 50858775281729,
  2905: 50858775314497,
  2916: 50858775347265,
  2920: 50858775380033,
  2933: 50858775412801,
  2940: 50858775445569,
  2949: 50858775478337,
  2951: 50858775511105,
  2952: 50858775543873,
  2961: 50858775576641,
  2975: 50858775609409,
  2991: 50858775642177,
  2994: 50858775674945,
  2995: 50858775707713,
  2999: 50858775740481,
  3000: 50858775773249,
  3003: 50858775806017,
  3005: 50858775838785,
  3010: 50858775871553,
  3032: 50858775904321,
  3073: 50858775937089,
  3080: 50858775969857,
  3098: 50858776002625,
  3099: 50858776035393,
  3101: 50858776068161,
  3114: 50858776100929,
  3143: 50858776133697,
  3145: 50858776166465,
  3150: 50858776199233,
  3160: 50858776232001,
  3161: 50858776264769,
  3192: 50858776297537,
  3195: 50858776330305,
  3196: 50858776363073,
  3199: 50858776395841,
  3213: 50858776428609,
  3220: 50858776461377,
  3241: 50858776494145,
  3272: 50858776526913,
  3280: 50858776559681,
  3283: 50858776592449,
  3290: 50858776625217,
  3294: 50858776657985,
  3295: 50858776690753,
  3299: 50858776723521,
  3300: 50858776756289,
  3320: 50858776789057,
  3325: 50858776821825,
  3352: 50858776854593,
  3353: 50858776887361,
  3354: 50858776920129,
  3360: 50858776952897,
  3364: 50858776985665,
  3380: 50858777018433,
  3381: 50858777051201,
  3384: 50858777083969,
  3387: 50858777116737,
  3395: 50858777149505,
  3399: 50858777182273,
  3400: 50858777215041,
  3423: 50858777247809,
  3430: 50858777280577,
  3432: 50858777313345,
  3440: 50858777346113,
  3451: 50858777378881,
  3465: 50858777411649,
  3493: 50858777444417,
  3495: 50858777477185,
  3499: 50858777509953,
  3500: 50858777542721,
  3512: 50858777575489,
  3520: 50858777608257,
  3549: 50858777641025,
  3563: 50858777673793,
  3570: 50858777706561,
  3592: 50858777739329,
  3594: 50858777772097,
  3595: 50858777804865,
  3599: 50858777837633,
  3600: 50858777870401,
  3633: 50858777903169,
  3645: 50858777935937,
  3648: 50858777968705,
  3672: 50858778001473,
  3680: 50858778034241,
  3699: 50858778067009,
  3703: 50858778099777,
  3704: 50858778132545,
  3752: 50858778165313,
  3760: 50858778198081,
  3773: 50858778230849,
  3774: 50858778263617,
  3780: 50858778296385,
  3789: 50858778329153,
  3799: 50858778361921,
  3800: 50858778394689,
  3806: 50858778427457,
  3815: 50858778460225,
  3832: 50858778492993,
  3843: 50858778525761,
  3864: 50858778558529,
  3870: 50858778591297,
  3894: 50858778624065,
  3899: 50858778656833,
  3900: 50858778689601,
  3912: 50858778722369,
  3913: 50858778755137,
  3920: 50858778787905,
  3960: 50858778820673,
  3975: 50858778853441,
  3992: 50858778886209,
  3999: 50858778918977,
  4014: 50858778951745,
  4025: 50858778984513,
  4031: 50858779017281,
  4032: 50858779050049,
  4043: 50858779082817,
  4044: 50858779115585,
  4050: 50858779148353,
  4053: 50858779181121,
  4060: 50858779213889,
  4070: 50858779246657,
  4072: 50858779279425,
  4074: 50858779312193,
  4080: 50858779344961,
  4101: 50858779377729,
  4121: 50858779410497,
  4123: 50858779443265,
  4125: 50858779476033,
  4152: 50858779508801,
  4160: 50858779541569,
  4165: 50858779574337,
  4193: 50858779607105,
  4194: 50858779639873,
  4196: 50858779672641,
  4199: 50858779705409,
  4232: 50858779738177,
  4245: 50858779770945,
  4250: 50858779803713,
  4263: 50858779836481,
  4300: 50858779869249,
  4312: 50858779902017,
  4314: 50858779934785,
  4320: 50858779967553,
  4321: 50858780000321,
  4333: 50858780033089,
  4360: 50858780065857,
  4361: 50858780098625,
  4374: 50858780131393,
  4380: 50858780164161,
  4392: 50858780196929,
  4395: 50858780229697,
  4399: 50858780262465,
  4400: 50858780295233,
  4401: 50858780328001,
  4403: 50858780360769,
  4410: 50858780393537,
  4472: 50858780426305,
  4473: 50858780459073,
  4480: 50858780491841,
  4494: 50858780524609,
  4495: 50858780557377,
  4499: 50858780590145,
  4500: 50858780622913,
  4531: 50858780655681,
  4543: 50858780688449,
  4554: 50858780721217,
  4560: 50858780753985,
  4595: 50858780786753,
  4600: 50858780819521,
  4608: 50858780852289,
  4613: 50858780885057,
  4614: 50858780917825,
  4620: 50858780950593,
  4632: 50858780983361,
  4640: 50858781016129,
  4644: 50858781048897,
  4655: 50858781081665,
  4674: 50858781114433,
  4680: 50858781147201,
  4683: 50858781179969,
  4693: 50858781212737,
  4698: 50858781245505,
  4699: 50858781278273,
  4700: 50858781311041,
  4712: 50858781343809,
  4720: 50858781376577,
  4734: 50858781409345,
  4753: 50858781442113,
  4788: 50858781474881,
  4792: 50858781507649,
  4794: 50858781540417,
  4795: 50858781573185,
  4799: 50858781605953,
  4800: 50858781638721,
  4823: 50858781671489,
  4865: 50858781704257,
  4872: 50858781737025,
  4883: 50858781769793,
  4893: 50858781802561,
  4896: 50858781835329,
  4899: 50858781868097,
  4900: 50858781900865,
  4952: 50858781933633,
  4963: 50858781966401,
  4975: 50858781999169,
  4984: 50858782031937,
  4994: 50858782064705,
  4999: 50858782097473,
  5032: 50858782130241,
  5033: 50858782163009,
  5040: 50858782195777,
  5041: 50858782228545,
  5094: 50858782261313,
  5103: 50858782294081,
  5110: 50858782326849,
  5112: 50858782359617,
  5120: 50858782392385,
  5154: 50858782425153,
  5173: 50858782457921,
  5192: 50858782490689,
  5214: 50858782523457,
  5225: 50858782556225,
  5243: 50858782588993,
  5250: 50858782621761,
  5272: 50858782654529,
  5280: 50858782687297,
  5291: 50858782720065,
  5295: 50858782752833,
  5298: 50858782785601,
  5299: 50858782818369,
  5313: 50858782851137,
  5320: 50858782883905,
  5352: 50858782916673,
  5361: 50858782949441,
  5383: 50858782982209,
  5392: 50858783014977,
  5394: 50858783047745,
  5432: 50858783080513,
  5454: 50858783113281,
  5460: 50858783146049,
  5475: 50858783178817,
  5499: 50858783211585,
  5500: 50858783244353,
  5512: 50858783277121,
  5523: 50858783309889,
  5560: 50858783342657,
  5565: 50858783375425,
  5574: 50858783408193,
  5592: 50858783440961,
  5593: 50858783473729,
  5663: 50858783506497,
  5672: 50858783539265,
  5680: 50858783572033,
  5692: 50858783604801,
  5694: 50858783637569,
  5700: 50858783670337,
  5725: 50858783703105,
  5731: 50858783735873,
  5741: 50858783768641,
  5752: 50858783801409,
  5754: 50858783834177,
  5795: 50858783866945,
  5799: 50858783899713,
  5814: 50858783932481,
  5832: 50858783965249,
  5840: 50858783998017,
  5873: 50858784030785,
  5874: 50858784063553,
  5880: 50858784096321,
  5912: 50858784129089,
  5915: 50858784161857,
  5934: 50858784194625,
  5943: 50858784227393,
  5950: 50858784260161,
  5975: 50858784292929,
  5992: 50858784325697,
  5994: 50858784358465,
  5995: 50858784391233,
  5999: 50858784424001,
  6000: 50858784456769,
  6011: 50858784489537,
  6013: 50858784522305,
  6072: 50858784555073,
  6092: 50858784587841,
  6100: 50858784620609,
  6144: 50858784653377,
  6152: 50858784686145,
  6155: 50858784718913,
  6180: 50858784751681,
  6215: 50858784784449,
  6225: 50858784817217,
  6240: 50858784849985,
  6265: 50858784882753,
  6270: 50858784915521,
  6293: 50858784948289,
  6294: 50858784981057,
  6295: 50858785013825,
  6312: 50858785046593,
  6354: 50858785079361,
  6360: 50858785112129,
  6363: 50858785144897,
  6392: 50858785177665,
  6399: 50858785210433,
  6472: 50858785243201,
  6495: 50858785275969,
  6500: 50858785308737,
  6510: 50858785341505,
  6570: 50858785374273,
  6594: 50858785407041,
  6599: 50858785439809,
  6643: 50858785472577,
  6650: 50858785505345,
  6712: 50858785538113,
  6713: 50858785570881,
  6760: 50858785603649,
  6780: 50858785636417,
  6792: 50858785669185,
  6800: 50858785701953,
  6853: 50858785734721,
  6872: 50858785767489,
  6894: 50858785800257,
  6965: 50858785833025,
  6975: 50858785865793,
  6993: 50858785898561,
  6995: 50858785931329,
  6999: 50858785964097,
  7014: 50858785996865,
  7063: 50858786029633,
  7100: 50858786062401,
  7160: 50858786095169,
  7170: 50858786127937,
  7192: 50858786160705,
  7194: 50858786193473,
  7195: 50858786226241,
  7210: 50858786259009,
  7272: 50858786291777,
  7295: 50858786324545,
  7315: 50858786357313,
  7331: 50858786390081,
  7343: 50858786422849,
  7344: 50858786455617,
  7374: 50858786488385,
  7440: 50858786521153,
  7470: 50858786553921,
  7499: 50858786586689,
  7585: 50858786619457,
  7592: 50858786652225,
  7600: 50858786684993,
  7665: 50858786717761,
  7672: 50858786750529,
  7693: 50858786783297,
  7700: 50858786816065,
  7770: 50858786848833,
  7794: 50858786881601,
  7795: 50858786914369,
  7799: 50858786947137,
  7832: 50858786979905,
  7846: 50858787012673,
  7855: 50858787045441,
  7899: 50858787078209,
  7944: 50858787110977,
  7960: 50858787143745,
  7975: 50858787176513,
  7992: 50858787209281,
  7999: 50858787242049,
  8015: 50858787274817,
  8043: 50858787307585,
  8050: 50858787340353,
  8070: 50858787373121,
  8072: 50858787405889,
  8240: 50858787438657,
  8360: 50858787471425,
  8365: 50858787504193,
  8370: 50858787536961,
  8392: 50858787569729,
  8393: 50858787602497,
  8400: 50858787635265,
  8475: 50858787668033,
  8700: 50858787700801,
  8715: 50858787733569,
  8725: 50858787766337,
  8743: 50858787799105,
  8760: 50858787831873,
  8792: 50858787864641,
  8800: 50858787897409,
  8970: 50858787930177,
  8994: 50858787962945,
  9043: 50858787995713,
  9065: 50858788028481,
  9093: 50858788061249,
  9160: 50858788094017,
  9192: 50858788126785,
  9200: 50858788159553,
  9270: 50858788192321,
  9415: 50858788225089,
  9431: 50858788257857,
  9475: 50858788290625,
  9500: 50858788323393,
  9560: 50858788356161,
  9570: 50858788388929,
  9592: 50858788421697,
  9600: 50858788454465,
  9745: 50858788487233,
  9765: 50858788520001,
  9793: 50858788552769,
  9899: 50858788585537,
  9960: 50858788618305,
  9992: 50858788651073,
  9998: 50858788683841,
  10115: 50858788716609,
  10143: 50858788749377,
  10300: 50858788782145,
  10360: 50858788814913,
  10392: 50858788847681,
  10465: 50858788880449,
  10470: 50858788913217,
  10475: 50858788945985,
  10493: 50858788978753,
  10600: 50858789011521,
  10760: 50858789044289,
  10770: 50858789077057,
  10780: 50858789109825,
  10815: 50858789142593,
  11070: 50858789175361,
  11141: 50858789208129,
  11160: 50858789240897,
  11192: 50858789273665,
  11543: 50858789306433,
  11560: 50858789339201,
  11592: 50858789371969,
  11865: 50858789404737,
  11893: 50858789437505,
  11960: 50858789470273,
  11992: 50858789503041,
  12215: 50858789535809,
  12360: 50858789568577,
  12500: 50858789601345,
  12565: 50858789634113,
  12943: 50858789666881,
  13125: 50858789699649,
  13192: 50858789732417,
  13560: 50858789765185,
  13592: 50858789797953,
  13960: 50858789830721,
  13993: 50858789863489,
  14343: 50858789896257,
  14360: 50858789929025,
  14595: 50858789961793,
  14600: 50858789994561,
  14693: 50858790027329,
  14792: 50858790060097,
  14970: 50858790092865,
  14988: 50858790125633,
  14994: 50858790158401,
  15000: 50858790191169,
  15043: 50858790223937,
  15192: 50858790256705,
  15470: 50858790289473,
  15475: 50858790322241,
  15992: 50858790355009,
  15995: 50858790387777,
  16000: 50858790420545,
  16093: 50858790453313,
  16392: 50858790486081,
  16730: 50858790518849,
  16792: 50858790551617,
  16793: 50858790584385,
  17192: 50858790617153,
  17493: 50858790649921,
  17592: 50858790682689,
  17815: 50858790715457,
  17832: 50858790748225,
  17994: 50858790780993,
  18165: 50858790813761,
  18193: 50858790846529,
  18392: 50858790879297,
  18815: 50858790912065,
  18865: 50858790944833,
  18995: 50858790977601,
  19192: 50858791010369,
  19565: 50858791043137,
  19593: 50858791075905,
  19600: 50858791108673,
  19992: 50858791141441,
  19995: 50858791174209,
  20360: 50858791206977,
  20643: 50858791239745,
  20760: 50858791272513,
  20792: 50858791305281,
  20993: 50858791338049,
  20994: 50858791370817,
  21070: 50858791403585,
  21560: 50858791436353,
  21693: 50858791469121,
  22194: 50858791501889,
  22291: 50858791534657,
  22360: 50858791567425,
  22392: 50858791600193,
  22393: 50858791632961,
  23592: 50858791665729,
  23992: 50858791698497,
  24493: 50858791731265,
  24792: 50858791764033,
  25592: 50858791796801,
  25893: 50858791829569,
  26593: 50858791862337,
  26693: 50858791895105,
  26994: 50858791927873,
  27992: 50858791960641,
  28194: 50858791993409,
  29994: 50858792026177,
  30392: 50858792058945,
  31500: 50858792091713,
  36000: 50858792124481,
  242000: 50858792157249,
  414608: 50858792190017
};